<template>
  <f7-page name="video">
    <f7-navbar id="navbar">
      <f7-nav-left>
        <img :src=$session_logo />
      </f7-nav-left>
      <f7-nav-right>
        <f7-link href="#" color="red" icon-f7="xmark_square" icon-only @click="terminate()"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom>
      <small style="color:gray;">{{ $t('copyright') }}</small>
    </f7-toolbar>

    <f7-block>
      <p id="message">{{ message_area }}</p>
      <f7-row id="hieroglyphs"> 
        <!-- f7-col class="text-align-center">{{ code }}</f7-col -->
        <f7-col class="text-align-center"><span style="font-size:3em;" :class="show_class[0]" id="hieroglyphs_1">{{ show[0] }}</span></f7-col>
        <f7-col class="text-align-center"><span style="font-size:3em;" :class="show_class[1]" id="hieroglyphs_2">{{ show[1] }}</span></f7-col>
        <f7-col class="text-align-center"><span style="font-size:3em;" :class="show_class[2]" id="hieroglyphs_3">{{ show[2] }}</span></f7-col>
        <f7-col class="text-align-center"><span style="font-size:3em;" :class="show_class[3]" id="hieroglyphs_4">{{ show[3] }}</span></f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="100" medium="50">
        <video class="video_capture rounded" ref="camera" autoplay playsinline muted="muted"/>
        <audio ref="remote_audio" autoplay playsinline />
        </f7-col>
      </f7-row>
    </f7-block>
  </f7-page>
</template>

<script>
import { f7, f7ready } from 'framework7-vue';
import { Janus } from 'janus-gateway';
import { v4 as uuidv4 } from 'uuid';
import { request, getDevice, getSupport } from 'framework7';

var acodec = null;
var feeds = [], feedStreams = {};
var localTracks = {}, localVideos = 0;
var mypvtid = null;
var mystream = null;
var sfutest = null;
var transactions = {};

// const vcodec = "h264";
const vcodec = "vp8";
const subscriber_mode = false;
const AI_SERVER='127.0.0.1';

export default {
  props: {
    f7router: Object,
    pin: String,
  },
  data() {
    return {
      code: "COD",
      digits: [],
      hieroglyphs: [],
      janus: null,
      mytrackid: null,
      myroom: null,
      opaqueId: null,
      session_id: null,
      show: [],
      show_class: [],
      message_area: "...",
      message_icon: "zzz",
      token: null,
      username: null,
      VIDEO_PORT: null,
      RTCP_PORT: null,
      http500_show_alert: true,
    };
  },
  mounted() {
    const self=this;

    for (let i=0;i<4;i++) {
      let hx='0x130'+parseInt(Math.random()*127).toString(16).padStart(2,'0');
      self.hieroglyphs[i]=String.fromCodePoint(hx);
      self.show_class[i]="active";
    }
    self.show=self.hieroglyphs;

    self.digits[0]=String.fromCodePoint(0x24EA);
    self.digits[1]=String.fromCodePoint(0x2460);
    self.digits[2]=String.fromCodePoint(0x2461);
    self.digits[3]=String.fromCodePoint(0x2462);
    self.digits[4]=String.fromCodePoint(0x2463);
    self.digits[5]=String.fromCodePoint(0x2464);

    self.username=uuidv4();
    self.opaqueId=uuidv4();
    
    if (localStorage.token) {
      self.token=localStorage.token;
      self.myroom=localStorage.token;
    }

    let startupConfig = { audio: false, video: true };
    navigator.mediaDevices.getUserMedia(startupConfig)
    .then(stream=> {
      Janus.init({
          debug: self.$janus_debug,
          dependencies: Janus.useDefaultDependencies(),
          callback: function() {
            self.connect(self.$janus_url);
          }
      });
    })
    .catch(err=>{
      console.log(err);
      f7.dialog.alert(
        self.$t('video-webrtc_permission_error'),
        ()=>{
          self.f7router.navigate('/permission');
        }
      );
    });
  },
  methods: {
    projector(obj) {
      const self=this;
      try {
        let text=obj["text"]
        let val=text.val;
        let pos=text.pos;
        self.message_icon=text.icon;

        if(pos==-2) {
          for (let i=1;i<4;i++) {
            self.show_class[i]="";
          }
        }

        if(pos>-1) {
          self.show[pos]=self.digits[val];
          self.show_class[pos]="";
          if(pos<4)
            self.show_class[pos+1]="active";
          self.message_area=self.$t('continue');
        } else { 
          self.message_area=text.message;
        }

      } catch (e) {
        console.log(e);
      }
    },
    http500(status, message) {
      const self=this;
      self.http500_show_alert=true;
      switch(status) {
        case 500:
          self.http500_show_alert=false;
          self.f7router.navigate('/error',{props:{status, message}});
          break;
        case 419:
          self.http500_show_alert=false;
          self.f7router.navigate('/expired');
          break;
      }
    },
    // CANCEL
    terminate() {
      const self=this;
      f7.dialog.confirm(
        self.$t('video_cancel-text'),
        self.$t('video_cancel'),
        ()=> {
          f7.preloader.show();
          request({
            beforeSend: function (xhr) {
              xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
            },
            method: 'post',
            url: '/v/video_cancel',
            success: function (data, status, xhr) {
              f7.preloader.hide();
              window.location.href="/";
            },
            error: function (xhr, status, message) {
              f7.preloader.hide();
              f7.dialog.alert('('+status+') '+message, self.$t('error'));
            },
            dataType: 'json'
          });
        });
    },
    connect(server) {
      const self=this;
      // console.log("connect to video server");
      if(self.session_id==null) {
        self.janus = new Janus({
          server,
          iceServers: [{urls: self.$ice_server_urls, username: self.$ice_server_username, credential: self.$ice_server_credential}],
          token: localStorage.token,
          success: function() {
            self.session_id=self.janus.getSessionId();
            self.message_area=self.$t('video_status-attaching-videoroom');
            self.message_icon='zzz';
            self.janus_attach_videoroom();
          },
          error: function(error) {
            self.notify_home("209: "+JSON.stringify(error));
            f7.dialog.alert(self.$t('video_error-connecting-to-server'));
          },
          destroyed: function(){
            self.f7router.navigate('/done',{ignoreCache:true,force:true});
          }
        })
      }
    },
    capture(mid) {
      const self = this;
      const device=getDevice();
      const support=getSupport();
      const janus_handler_id = sfutest.getId();

      f7.preloader.show();
      request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
        },
        async: false,
        method: 'post',
        url: '/v/video_capture',
        data: {
          janus_session_id: self.session_id,
          janus_handler_id: janus_handler_id,
          janus_publisher_id: self.myid,
          desktop: device.desktop,
          mid: mid,
        },
        success: function (data, status, xhr) {
          f7.preloader.hide();
          // console.log(data);
        },
        error: function (xhr, status, message) {
          f7.preloader.hide();
          self.http500(status);
          if(self.http500_show_alert)
            f7.dialog.alert('('+status+') '+message, self.$t('error'));
        },
        dataType: 'json',
      });
    },
    janus_attach_videoroom() {
      const self=this;
      self.janus.attach({
        plugin: "janus.plugin.videoroom",
        opaqueId: self.opaqueId,
        success: function(pluginHandle) {
          sfutest = pluginHandle;
          // register the user with the room
          var register = {
            request: "join",
            room: self.myroom,
            ptype: "publisher",
            display: self.username,
            pin: self.pin,
          };
          // console.log(register);
          setTimeout(function(){
            sfutest.send({ message: register });
          }, 500);
        },
        error: function(error) {
          self.notify_home("273: "+JSON.stringify(error));
          f7.dialog.alert(self.$t('video_error-technical-issue') + ' VIDEO:' + error);
        },
        consentDialog: function(on) {
          if(on) {
            f7.preloader.show();
          } else {
            f7.preloader.hide();
          }
        },
        iceState: function(state) {
          // video ice state changed to state
        },
        mediaState: function(medium, on, mid) {
          // ready, start forward
          if(medium=="video" && on) {
            self.capture(mid);
          }
        },
        webrtcState: function(on) {
          // if(!on) return;
        },
        slowLink: function(uplink, lost, mid) {
          // nothing
        },
        onmessage: function(msg, jsep) {
          var event = msg["videoroom"];
          if(event) {
            if(event === "joined") {
              self.myid = msg["id"];
              var mypvtid = msg["private_id"];
              self.publishOwnFeed(sfutest, false);
              if(msg["publishers"]) {
                var list = msg["publishers"];
                // console.log("Joined => got a list of available publishers/feeds:", list);
                for(var f in list) {
                  var id = list[f]["id"];
                  var streams = list[f]["streams"];
                  for(var i in streams) {
                    var stream = streams[i];
                    stream["id"] = id;
                    stream["display"] = display;
                  }
                  feedStreams[id] = streams;
                  // console.log("Joined => [" + id + "] " + display + ":", streams);
                  self.newRemoteFeed(id, display, streams);
                }
              }
            } else if(event === "destroyed") {
              self.janus.destroy();
            } else if(event === "event") {
              if(msg["streams"]) {
                // nothing
              } else if(msg["publishers"]) {
                var list = msg["publishers"];
                // console.log("Event => Got a list of available publishers/feeds:", list);
                for(var f in list) {
                  var id = list[f]["id"];
                  var display = list[f]["display"];
                  var streams = list[f]["streams"];
                  for(var i in streams) {
                    var stream = streams[i];
                    stream["id"] = id;
                    stream["display"] = display;
                  }
                  feedStreams[id] = streams;
                  // console.log("Event => [" + id + "] " + display + ":", streams);
                  self.newRemoteFeed(id, display, streams);
                }
              } else if(msg["leaving"]) {
                // one of the publishers has gone away?
              } else if(msg["unpublished"]) {
                var unpublished = msg["unpublished"];
                if(unpublished === 'ok') {
                  sfutest.hangup();
                  return;
                }
              } else if(msg["error"]) {
                if(msg["error_code"] === 426) {
                  self.notify_home("352: "+JSON.stringify(msg["error"]));
                  f7.dialog.alert(
                    self.$t('video_error-camera-doesnt-exist_1') + self.myroom + self.$t('video_error-camera-doesnt-exist_2')
                  );
                } else {
                  self.notify_home("357: "+JSON.stringify(msg["error"]));
                  f7.dialog.alert(msg["error"]);
                }
              }
            }
          }
          if(jsep) {
            sfutest.handleRemoteJsep({ jsep: jsep });
            var audio = msg["audio_codec"];
            if(mystream && mystream.getAudioTracks() && mystream.getAudioTracks().length > 0 && !audio) {
              f7.dialog("Avertizare AUDIO - sunetul nu functioneaza, nimeni nu ne poate auzi.");
            }
            var video = msg["video_codec"];
            if(mystream && mystream.getVideoTracks() && mystream.getVideoTracks().length > 0 && !video) {
              f7.dialog("Avertizare VIDEO - captura de imagine nu functioneaza, nimeni nu ne poate vedea.");
            }
          }
        },
        onlocaltrack: function(track, on) {
          var trackId = track.id.replace(/[{}]/g, "");
          if(!on) {
            var stream = localTracks[trackId];
            if(stream) {
              try {
                var tracks = stream.getTracks();
                for(var i in tracks) {
                  var mst = tracks[i];
                  if(mst !== null && mst !== undefined)
                    mst.stop();
                }
              } catch(e) {
                self.notify_home("388: "+JSON.stringify(e));
              }
            }
            if(track.kind === "video") {
              localVideos--;
              /*if(localVideos === 0) {
                 console.log("No video, at least for now: show a placeholder");
              }*/
            }
            delete localTracks[trackId];
            return;
          }
          var stream = localTracks[trackId];
          if(stream) {
            return;
          }
          if(track.kind === "audio") {
            // if(localVideos === 0) { /* no video, do nothing */ }
          } else {
            localVideos++;
            stream = new MediaStream();
            stream.addTrack(track.clone());
            localTracks[trackId] = stream;
            self.mytrackid=trackId;
            try {
              self.$refs.camera.srcObject = stream;
            } catch (e) {
              try {
                self.$refs.camera.src = URL.createObjectURL(stream);
              } catch (e) {
                self.notify_home("418: "+JSON.stringify(e));
                f7.dialog.alert(self.$t('video_error-attaching-local-videofeed'));
              }
            }
          }
          if(sfutest.webrtcStuff.pc.iceConnectionState !== "completed" && sfutest.webrtcStuff.pc.iceConnectionState !== "connected") {
            f7.preloader.show();
          }
        },
        onremotetrack: function(track, mid, on) {
          // The publisher stream is sendonly, we don't expect anything here
        },
        ondataopen: function(data) {
          // console.log("The DataChannel is available!");
        },
        ondata: function(data) {
          // console.log("We got data from the DataChannel!");
        },
        oncleanup: function() {
          var stream = localTracks[self.mytrackid];
          if(stream) {
            try {
              var tracks = stream.getTracks();
              for(var i in tracks) {
                var mst = tracks[i];
                if(mst !== null && mst !== undefined)
                  mst.stop();
              }
            } catch(e) {}
          }
          mystream = null;
          delete feedStreams[self.myid];
          localTracks = {};
          localVideos = 0;

          self.janus.destroy();
        },
      });
    },
    // notify home
    notify_home(msg) {
      request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
        },
        method: 'post',
        url: '/v/notify_home',
        data: {
          note: msg,
        },
        dataType: 'json',
        success: function (data, status, xhr) {
          // do nothing
        },
        error: function (xhr, status, message) {
          // do nothing
        }
      });
    },
    // publishOwnFeed
    publishOwnFeed(sfutest, useAudio) {
      // Publish our stream
      const self=this;
      let doSimulcast=false;
      let doDtx=false;
      sfutest.createOffer(
        {
          media: { audioRecv: false, videoRecv: false, audioSend: useAudio, videoSend: true },
          iceRestart: true,
          simulcast: doSimulcast,
          customizeSdp: function(jsep) {
            // if dtx is enabled, munge the sdp
            if(doDtx) {
              jsep.sdp = jsep.sdp
                .replace("useinbandfec=1", "useinbandfec=1;usedtx=1")
            }
          },
          success: function(jsep) {
            // got publisher sdp!
            var publish = { request: "configure", audio: useAudio, video: true };
            if(acodec)
              publish["audiocodec"] = acodec;
            if(vcodec)
              publish["videocodec"] = vcodec;
            sfutest.send({ message: publish, jsep: jsep });
          },
          error: function(error) {
            // WebRTC error
            self.notify_home("506: "+JSON.stringify(error));
            if(useAudio) {
              publishOwnFeed(sfutest, false);
            } else {
              self.notify_home("510: "+JSON.stringify(error.message));
              alert(self.$t('video_error-technical-issue') + ' WebRTC:' + error.message);
              window.location.reload();
            }
          }
        });
    },
    newRemoteFeed(id, display, streams) {
      const self=this;
      // console.log("A new feed has been published, create a new plugin handle and attach to it as a subscriber");
      var remoteFeed = null;
      if(!streams)
        streams = feedStreams[id];
      self.janus.attach(
        {
          plugin: "janus.plugin.videoroom",
          opaqueId: self.opaqueId,
          success: function(pluginHandle) {
            remoteFeed = pluginHandle;
            remoteFeed.remoteTracks = {};
            remoteFeed.remoteVideos = 0;
            remoteFeed.simulcastStarted = false;
            // Prepare the streams to subscribe to, as an array: we have the list of
            // streams the feed is publishing, so we can choose what to pick or skip
            var subscription = [];
            for(var i in streams) {
              var stream = streams[i];
              // If the publisher is VP8/VP9 and this is an older Safari, let's avoid video
              subscription.push({
                feed: stream.id,	// This is mandatory
                mid: stream.mid		// This is optional (all streams, if missing)
              });
            }
            // We wait for the plugin to send us an offer
            var subscribe = {
              request: "join",
              room: self.myroom,
              ptype: "subscriber",
              streams: subscription,
              pin: self.pin,
              // private_id: mypvtid
            };
            remoteFeed.send({ message: subscribe });
          },
          error: function(error) {
            // -- Error attaching plugin...
          },
          iceState: function(state) {
            // ICE state changed to state
          },
          webrtcState: function(on) {
            // Janus says this WebRTC PeerConnection is up/down
          },
          slowLink: function(uplink, lost, mid) {
            // Janus reports problems uplink ...
          },
          onmessage: function(msg, jsep) {
            var event = msg["videoroom"];
            if(msg["error"]) {
              console.log(msg["error"]);
            } else if(event) {
              if(event === "attached") {
                // Subscriber created and attached
                for(var i=1;i<6;i++) {
                  if(!feeds[i]) {
                    feeds[i] = remoteFeed;
                    remoteFeed.rfindex = i;
                    break;
                  }
                }
                // console.log(feeds);
              } else if(event === "event") {
                // Check if we got a simulcast-related event from this publisher
              } else {
                // What has just happened?
              }
            }
            if(jsep) {
              // console.log(jsep);
              var stereo = (jsep.sdp.indexOf("stereo=1") !== -1);
              remoteFeed.createAnswer(
                {
                  jsep: jsep,
                  // Add data:true here if you want to subscribe to datachannels as well
                  media: { audioSend: false, videoSend: false, data: true },
                  customizeSdp: function(jsep) {
                    if(stereo && jsep.sdp.indexOf("stereo=1") == -1) {
                      // Make sure that our offer contains stereo too
                      jsep.sdp = jsep.sdp.replace("useinbandfec=1", "useinbandfec=1;stereo=1");
                    }
                  },
                  success: function(jsep) {
                    var body = { request: "start", room: self.myroom };
                    remoteFeed.send({ message: body, jsep: jsep });
                  },
                  error: function(error) {
                    console.log("WebRTC error:", error);
                  }
                });
            }
          },
          onlocaltrack: function(track, on) {
            // The subscriber stream is recvonly, we don't expect anything here
          },
          onremotetrack: function(track, mid, on) {
            if(!on) {
              // Track removed, get rid of the stream and the rendering
              var stream = remoteFeed.remoteTracks[mid];
              if(stream) {
                try {
                  var tracks = stream.getTracks();
                  for(var i in tracks) {
                    var mst = tracks[i];
                    if(mst !== null && mst !== undefined)
                      mst.stop();
                  }
                } catch(e) {}
              }
              delete remoteFeed.remoteTracks[mid];
              return;
            }
            if(track.kind === "audio") {
              stream = new MediaStream();
              stream.addTrack(track.clone());
              remoteFeed.remoteTracks[mid] = stream;
              // console.log("Created remote audio stream:", stream);
              self.$refs.remote_audio.srcObject=stream;
              // console.log(self.$refs.remote_audio.srcObject);
            }
          },
          ondata: function(data) {
            var obj = JSON.parse(data);
            self.projector(obj);
          },
          oncleanup: function() {
            /*if(bitrateTimer[remoteFeed.rfindex])
              clearInterval(bitrateTimer[remoteFeed.rfindex]);
            bitrateTimer[remoteFeed.rfindex] = null;
            remoteFeed.simulcastStarted = false;
            remoteFeed.remoteTracks = {};
            remoteFeed.remoteVideos = 0; */
          },
        });
    }
    // end.
  },
};
</script>
